import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'nx-contact',
  templateUrl: './nx-contact.component.html',
  styleUrls: ['./nx-contact.component.scss']
})
export class NxContactComponent implements OnInit {

  @Input() language: boolean;
  
  constructor() { }

  ngOnInit(): void {
  }

}
